<div [className]="cssPropertiesEnum.bodyClasses|cssProperty: vHostService" class="app">
  <div class="row app__row">
    @if (hideNavigation) {
      <div class="col-md-12 mt-3 app__main app__main--full">
        <div class="container-fluid p-0 app__container">
          @if (useBreadCrumb) {
            <app-breadcrumb class="app__breadcrumb"></app-breadcrumb>
          }
          <div style="width:100%" class="app__content">
            <router-outlet class="app__router-outlet"></router-outlet>
          </div>
        </div>
      </div>
    } @else {
      @if (!useBreadCrumb) {
        <div [className]="(horizontalNavigation ? 'col-md-12' : 'col-md-3') + ' app__navigation'">
          <app-navigation [horizontalNavigation]="horizontalNavigation"
                          class="app__navigation-component"></app-navigation>
        </div>
      }
      <div [className]="(horizontalNavigation ? 'col-md-12' : 'col-md-9') + (!useBreadCrumb ? ' mt-3' : '') + ' app__main app__main--with-nav'">
        <div class="container-fluid p-0 app__container">
          @if (useBreadCrumb) {
            <app-breadcrumb class="app__breadcrumb"></app-breadcrumb>
          }
          <div style="width:100%" class="app__content">
            <router-outlet class="app__router-outlet"></router-outlet>
          </div>
        </div>
      </div>
    }
  </div>
</div>
